export const organisation = {
  title: "Organisation",
  subtitle: "Manage organisations and their details",
  health_title: "Customer account",
  health_subtitle: "Manage accounts and their details",
  sub_organisations_title: "Sub Organisations for",
  sub_organisations_subtitle:
    "Add a sub organisation and define its basic details. Permissions and users can be managed later.",
  health_sub_organisations_title: "Accommodations for",
  health_sub_organisations_subtitle:
    "Add an accommodation and define its basic details. Permissions and users can be managed later.",
  no_sub_organisation_option: "No Sub-organisation",
  health_no_sub_organisation_option: "No Accommodation",
  add_sub_organisation_title: "Add New Sub Organisation",
  add_sub_organisation_subtitle:
    "Create a new sub organisation and add its basic details. Permissions and users can be managed at any time.",
  health_add_sub_organisation_title: "Add New Accommodation",
  health_add_sub_organisation_subtitle:
    "Create a new accommodation and add its basic details. Permissions and users can be managed at any time.",
  no_sub_organisations_title: "No sub organisations yet",
  no_sub_organisations_subtitle:
    "Create a sub organisation to manage users and activities.",
  health_no_sub_organisations_title: "No accommodations yet",
  health_no_sub_organisations_subtitle:
    "Create an accommodation to manage users and activities.",
  create_new: "Create New +",
  organisation_name: "Organisation Name",
  organisation_number: "Organisation Number",
  health_organisation_name: "Account Name",
  health_organisation_number: "Account Number",
  health_sub_organisation_name: "Accommodation Name",
  location: "Location",
  action: "Action",

  // Add Organisation Screen
  add_title: "Add New Organisation",
  health_add_title: "Add New Customer Account",
  add_subtitle:
    "Create a new organisation and add its basic details. You can assign permissions and users at any time.",
  health_add_subtitle:
    "Create a new customer account and add its basic details. You can assign permissions and users at any time.",
  basic_information: "Basic Information",
  organisation_name_label: "Organisation Name",
  sub_organisation_name_label: "Sub Organisation Name",
  health_organisation_name_label: "Customer account",
  health_sub_organisation_name_label: "Accommodations",
  organisation_number_label: "Organisation Number",
  address: "Address",
  second_address: "Second Address",
  postal_code: "Postal Code",
  location_label: "Location",
  have_sub_organisation: "Have Sub-organisation",
  sub_org_info:
    "If enabled sub-organisations will be used. Otherwise, departments will be used.",
  process_owner_title: "Process Owner - Permission 1 (Company account owner)",
  process_owner_title_2:
    "Process Owner - Permission 2 (Sub Organisation or Department account owner)",
  health_process_owner_title_2:
    "Process Owner - Permission 2 (Accommodation account owner)",
  process_owner_title_3:
    "Process Owner - Permission 3 (Admin for department or sub organisation)",
  health_process_owner_title_3:
    "Process Owner - Permission 3 (Admin for accommodation)",
  person_email: "Person's email",
  add_button: "Add",
  selected_persons: "Selected persons",
  add_new_organisation: "Add New Organisation",
  add_and_close: "Add & Close",
  cancel: "Cancel",

  // Placeholders
  placeholder_organisation_name: "Enter organisation name",
  health_placeholder_organisation_name: "Enter account name",
  placeholder_sub_organisation_name: "Enter sub organisation name",
  health_placeholder_sub_organisation_name: "Enter accommodation name",
  placeholder_organisation_number: "Enter organisation number",
  health_placeholder_organisation_number: "Enter account number",
  placeholder_address: "Write your address here",
  placeholder_second_address: "Write your second address here",
  placeholder_postal_code: "Enter postal code",
  placeholder_location: "Enter location",
  placeholder_person_email: "Enter email address here...",

  // Error messages
  error_email_required: "Email is required",
  error_email_invalid: "Please enter a valid email address",
  error_email_already_added: "This email has already been added",

  // Edit Organisation Screen
  edit_title: "Edit Organisation",
  health_edit_title: "Edit Account",
  health_edit_sub_title: "Edit Accommodation",
  edit_subtitle: "Update basic information and permissions",
  save_changes: "Save changes",
  delete_button: "Delete",

  // Notifications
  delete_success: "Organisation deleted successfully",
  delete_error: "Failed to delete organisation",
  create_success: "Organisation created successfully",
  create_success_but_admins_failed:
    "Organisation created, but assigning some admins failed.",
  error_conflict_connected:
    "This account is connected with the other organisation.",
  create_error: "Failed to create organisation",
  update_success: "Organisation updated successfully",
  update_error: "Failed to update organisation",
  load_error: "Failed to load organisation data",

  // Confirmation Dialog
  confirm_delete_title: "Delete Organisation",
  confirm_delete_message: "Are you sure you want to delete this organisation?",
  confirm_delete_yes: "Yes, Delete",

  // Sub-organisation delete
  confirm_delete_sub_org_title: "Delete Sub-Organisation",
  confirm_delete_sub_org_message:
    "Are you sure you want to delete this sub-organisation?",
  delete_sub_org_success: "Sub-organisation deleted successfully",
  delete_sub_org_error: "Failed to delete sub-organisation",

  //Add sub organisation
  show_qr_code: "Show QR Code",
  assign_responsible_users:
    "Assign responsible users for this sub organisation.",

  // Custom notifications for sub-organisation/accommodation
  accommodation_create_success: "Accommodation created successfully",
  accommodation_update_success: "Accommodation updated successfully",
  accommodation_create_error: "Failed to create accommodation",
  accommodation_update_error: "Failed to update accommodation",
  suborg_create_success: "Sub-organisation created successfully",
  suborg_update_success: "Sub-organisation updated successfully",
  suborg_create_error: "Failed to create sub-organisation",
  suborg_update_error: "Failed to update sub-organisation",
};
